import React, { useEffect, useRef } from 'react';
import './ServicesSection.css';
import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';

import trasladosImg from '../../../assets/Traslados.png';
import sensacionesImg from '../../../assets/Holbox.png';
import toursImg from '../../../assets/Tour.png';
import cenasImg from '../../../assets/Cenas.png';

interface ServiceData {
  title: string;
  image: string;
  link: string;
}

const imageMap: { [key: string]: string } = {
  traslados: trasladosImg,
  sensaciones: sensacionesImg,
  tours: toursImg,
  cenas: cenasImg,
};

const ServicesSection: React.FC = () => {
  
  const { t, i18n } = useTranslation(); 
  const currentLang = i18n.language.split('-')[0];

  
  const servicesJson = t('services:list', { returnObjects: true }) as any[] | undefined;
  
  const servicesData: ServiceData[] = Array.isArray(servicesJson)
    ? servicesJson.map((s) => ({
        title: s.title,
        image: s.imageKey,
        link: s.link,
      }))
    : []; 

  const itemsRef = useRef<HTMLDivElement[]>([]);
  itemsRef.current = itemsRef.current.slice(0, servicesData.length);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    itemsRef.current.forEach((item) => {
      if (item) observer.observe(item);
    });

    return () => observer.disconnect();
  }, [servicesData.length]); 

  return (
    <section className="services-section">
      <div className="section-header">
        <h2 className="section-header-text">
          <Trans i18nKey="services:sectionTitle" />
        </h2>
      </div>

      <div className="services-grid">
        {servicesData.map((service, index) => (
          <div
            key={index}
            className="service-item animate"
            ref={(el) => { if (el) itemsRef.current[index] = el; }}
          >
            <img
              src={imageMap[service.image] ?? trasladosImg}
              alt={service.title}
              className="service-image"
            />
            <div className="service-info">
              <div className="service-header-with-icon">
                <h3 className="service-title">
                  {service.title}
                </h3>
              </div>

              <Link to={`/${currentLang}${service.link}`} className="discover-more-button">
                <Trans i18nKey="services:moreInfo" />
              </Link>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ServicesSection;